module.exports = __webpack_public_path__ + "img/light-1.ba79e7e5.svg";